<template>
  <div class="kpt-flip-container" 
  :class="{ 'kpt-flip-hover': flipped }"
  :style="{ width: width, height: height }">
    <div class="kpt-flipper">
      <div class="kpt-flipper-front">
        <slot name="front" v-bind:toggle="toggle"></slot>
      </div>
      <div class="kpt-flipper-back">
        <slot name="back" v-bind:toggle="toggle"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      flipped: false
    }
  },
  methods: {
    toggle() {
      this.flipped = !this.flipped;
      this.$emit('input', this.flipped);
    }
  },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    }
  }
}
</script>
<style lang="scss" scoped>
.kpt-flip-container {
  perspective: 1000px;
  display: block;
  position: relative;

  &.kpt-flip-hover {
    .kpt-flipper {
      transform: rotateX(180deg);
    }
  }

  .kpt-flipper {
    transition: 0.6s;
    transform-style: preserve-3d;
    position: relative;
    width: 100%;
    height: 100%;
    transform-origin: 100%;

    .kpt-flipper-front, .kpt-flipper-back {
      transform-style: preserve-3d;
      backface-visibility: hidden;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    .kpt-flipper-front {
      z-index: 2;
      transform: rotateX(0deg);
    }

    .kpt-flipper-back {
      transform: rotateX(-180deg);
    }
  }  
}
</style>
